import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lumiere_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Resolve an image reference to a full URL. External URLs pass through;
// storage paths are served via the backend file endpoint.
export function resolveImg(img) {
  if (!img) return "";
  if (img.startsWith("http")) return img;
  return `${API}/files/${img}`;
}

export function formatPrice(p) {
  return p ? `$${Number(p).toLocaleString()}` : "Price on request";
}

export { API };
export default api;
